<div class="container">
  <div class="card">
    <div class="task-head">
      <h4 *ngIf="data?.message === 'success'">Success!</h4>
       <h4 *ngIf="data?.message !== 'success'">Warning!</h4>
    </div>

    <p *ngIf="data?.message === 'countryblock'">The operator has not allowed the tasking of the sensor from your country
      of registration. Please continue with other sensors.</p>
    <p *ngIf="data?.message === 'fail' || data?.message === 'taskFail'">
      An error occurred during processing and ingestion of the request. Please try after sometime.
    </p>
    <p *ngIf=" data?.message === 'outcomeFail' || data?.message === 'budgetFail' || data?.message === 'Allocation Failed'">
      {{data?.response}}
    </p>
    <p *ngIf="data?.message === 'target'">
      {{data?.info}}. Please try again.
    </p>
    <p *ngIf="data?.message === 'warning'">
      {{data?.info}}
      <mat-progress-bar *ngIf="data?.message === 'warning'" class="cesium-progress-bar"
        mode="indeterminate"></mat-progress-bar>
    </p>
    <p *ngIf="data?.message === 'success'">
      {{data?.info}}
    </p>
  </div>

  <div class="btns">
    <button *ngIf="data?.message === 'countryblock'" mat-flat-button (click)="onNoClick()">Continue</button>
    <button *ngIf="data?.message === 'fail'" mat-flat-button routerLink="/task" (click)="onNoClick()">Ok, Thanks</button>
    <button *ngIf="data?.message === 'outcomeFail' || data?.message === 'taskFail' || data?.message === 'Allocation Failed'" mat-flat-button (click)="onNoClick()">Ok, Thanks</button>
    <button *ngIf="data?.message === 'budgetFail'" mat-flat-button  (click)="onNoClick()">Ok,
      Thanks</button>
    <button *ngIf="data?.message === 'target' || data?.message === 'success'" mat-flat-button (click)="onNoClick()">Ok, Thanks</button>
    <button *ngIf="data?.message === 'warning'" mat-flat-button (click)="onNoClick()">Close</button>
  </div>
</div>